export var InputTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: theme.typography.body1.fontSize,
                marginTop: "0 !important",
                input: {
                    // padding: `9.95px 14px`,
                    padding: theme.spacing(1.24375, 1.75),
                },
                '&.MuiInputBase-sizeLarge': {
                    input: {
                        padding: theme.spacing(2.24375, 1.75)
                        // padding: `17.95px 14px`,
                    },
                },
            });
        },
        sizeSmall: {
            input: function (_a) {
                var theme = _a.theme;
                return ({
                    // padding: `5.95px 8px`,
                    padding: theme.spacing(0.74375, 1)
                });
            },
        },
    },
}); };
export default InputTheme;
//# sourceMappingURL=theme.js.map